module.exports = "//trvimg.r10s.jp/share/m17n/edfbdc52c3accfa5715efcf49a975a22.svg";


// WEBPACK FOOTER //
// ./~/url-loader?limit=10000&mimetype=image/svg+xml&publicPath=/trvimg.r10s.jp/share/m17n/!./src/img/common/icons/pink.svg